import React from 'react';
type LeafSprigProps = {
  className?: string;
};

/** A quiet botanical sprig echoing the leaves on the product covers. */
export function LeafSprig({
  className = ''
}: LeafSprigProps) {
  return <svg viewBox="0 0 64 140" fill="none" aria-hidden="true" className={className} data-id="element-35" data-mp="19tuvlhv6ktft">
      <path d="M32 138 C 31 100, 30 60, 36 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" data-id="element-36" data-mp="1ekutapc4jfjd" />
      <path d="M31 112 C 18 108, 9 97, 7 84 C 20 86, 29 97, 31 112Z" fill="currentColor" opacity="0.85" data-id="element-37" data-mp="1jkpkktzta74y" />
      <path d="M32 96 C 45 92, 54 81, 56 68 C 43 70, 34 81, 32 96Z" fill="currentColor" opacity="0.7" data-id="element-38" data-mp="1oihmmgu679mv" />
      <path d="M32 74 C 20 70, 12 60, 10 48 C 22 50, 30 60, 32 74Z" fill="currentColor" opacity="0.85" data-id="element-39" data-mp="1ti408rdwurw7" />
      <path d="M33 56 C 45 52, 52 42, 54 31 C 42 33, 35 43, 33 56Z" fill="currentColor" opacity="0.7" data-id="element-40" data-mp="1xixmlgbpfymz" />
      <path d="M34 34 C 24 30, 18 22, 17 12 C 27 14, 33 22, 34 34Z" fill="currentColor" opacity="0.85" data-id="element-41" data-mp="3vas5t7e11rf5" />
    </svg>;
}